import React from "react";
import { Form, ModalBuilder } from "@redriver/cinnamon";
import { useTranslation } from "react-i18next";
import { TranslatedModal } from "../../../../../../shared/components/modals";
import { setCurrentSchedule } from "./actions";
import { DropdownItem } from "semantic-ui-react";
import { NonPropagatingInput } from "features/../../../shared/components/forms/NonPropagatingField";

const SetCurrentSchedule = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, currentScheduleReference, revisionNumber } = sheet;

  return (
    <ModalBuilder
      withForm
      initialData={{ currentScheduleReference, revisionNumber }}
      submitParams={{ sheetId }}
      submitAction={setCurrentSchedule}
      onSubmitted={onSubmitted}
      renderTrigger={(onTrigger) => (
        <DropdownItem onClick={onTrigger}>
          {t("SheetActions.SetCurrentSchedule.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          header={t("SheetActions.SetCurrentSchedule.ModalHeader")}
          submitText={t("SheetActions.SetCurrentSchedule.ModalSubmit")}
        >
          <Form {...formProps}>
            <NonPropagatingInput
              field="currentScheduleReference"
              maxLength={50}
            />
            <NonPropagatingInput
              field="revisionNumber"
              maxLength={50}
              label={t("SheetActions.SetCurrentSchedule.RevisionNumber")}
            />
          </Form>
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default SetCurrentSchedule;
